<template>
    <el-dropdown
	    @command="handleCommand"
	    ref="dropdownRef"
    >
        <div style="cursor: pointer;white-space: nowrap; display: flex; align-items: center;">
	        <SvgIcon :name="langIcon" class-name="lang-icon" />
            <span class="label" :style="props.labelStyles">{{ label }}</span>
            <el-icon
	            class="el-icon--right"
	            size="18"
	            :color="mode === 'dark' ? '#333' : '#fff'"
            >
                <arrow-down />
            </el-icon>
        </div>
        <template #dropdown>
            <el-dropdown-menu>
                <div
	                v-for="option in options"
	                :key="option.value"
	                @click="handleCommand(option)"
	                class="dropdown-item"
                >
                    {{ option.label }}
                </div>
            </el-dropdown-menu>
        </template>
    </el-dropdown>
</template>

<script setup>
import { computed,onMounted, ref } from 'vue'
import SvgIcon from "@/components/SvgIcon/SvgIcon.vue";

const props = defineProps(['placeholder', 'options', 'labelStyles', 'modelValue', 'mode'])
const emits = defineEmits(['update:modelValue'])

const dropdownRef  =ref(null)

const langIcon = computed(() => props.mode === 'light' ? 'language' : 'language-dark')

const label = computed(() => {
    if (props.modelValue) {
        return props.modelValue.label
    }

    return props.placeholder
})

function handleCommand(e) {
	dropdownRef.value?.handleClose()
    console.log(e)
    emits('update:modelValue', { ...e })
}

</script>
<style lang="less">
    .label{
        font-size: 18px;
    }
    
    .lang-icon {
	    margin-right: 10px;
    }
    
    .dropdown-item {
	    padding: 5px 16px;
	    white-space: nowrap;
	    cursor: pointer;
	    
	    &:hover {
		    background-color: rgba(218, 36, 27, .1);
		    color: @primary-color;
	    }
    }
</style>